module.exports = __webpack_public_path__ + "static/media/hamamo_bottom_logo_baydiamond.e45381dc.png";